import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { createBusiness, getBusiness, listBusinesses, listIndividualBusinesses, queryBusinesses } from '@wix/ambassador-asa-business-v1-business/http';
import { HttpBaseClient } from '../BaseClient/HttpBaseClient';
import { BusinessClientBase } from './BusinessClientBase';
export class BusinessClient extends HttpBaseClient(BusinessClientBase) {
  constructor() {
    super(...arguments);
    _defineProperty(this, "createBusinessesImpl", createBusiness);
    _defineProperty(this, "getBusinessImpl", getBusiness);
    _defineProperty(this, "listBusinessesImpl", listBusinesses);
    _defineProperty(this, "listIndividualBusinessesImpl", listIndividualBusinesses);
    _defineProperty(this, "queryBusinessesImpl", queryBusinesses);
  }
}
//# sourceMappingURL=BusinessClientHttp.js.map